import { render } from "./SearchConfigurationPrompt.vue?vue&type=template&id=c2dcabf2&scoped=true"
import script from "./SearchConfigurationPrompt.vue?vue&type=script&lang=js"
export * from "./SearchConfigurationPrompt.vue?vue&type=script&lang=js"

import "./SearchConfigurationPrompt.vue?vue&type=style&index=0&id=c2dcabf2&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\Normann\\Configurator Dashboard\\normann-dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2dcabf2"]])

export default __exports__